import classNames from 'classnames';

import {ArchiveOptions, ItemForArchive} from 'archive/ArchiveConstants';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

export interface ArchiveTableRowProps {
  itemForArchive: ItemForArchive;
  options: ArchiveOptions;
  dataTestAttrs?: DataTestAttrs;
}

export function getRowClassName(itemForArchive: ItemForArchive, options: ArchiveOptions): string {
  return classNames({
    'u-faded u-strike-through': itemForArchive.isShortcut && options.shouldRemoveShortcuts,
  });
}
